/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { GrLinkNext } from 'react-icons/gr';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import pregnantWomen from 'assets/images/two-pregnant-women.webp';
import pregnantWoman from 'assets/images/pregnant-woman.webp';
import pregnantWoman1 from 'assets/images/pregnant-woman-1.webp';
import pregnancyShape from 'assets/images/pregnancy-shape2.png';
import star from 'assets/images/star.png';
import rose from 'assets/images/rose.png';
import smile from 'assets/images/smile.svg';
import tablet from 'assets/images/tablet.svg';
import headphones from 'assets/images/headphones.svg';
import { useGetParams } from '../utils/useGetParams';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { ROUTES } from 'utils/constants';
import { KEYS } from '../utils/constants';
import { handleTrackEvent } from '../utils/handleTrackEvent';
import { useEvieOnboardingContext } from '../EvieOnboardingProvider';

import InfoScreen from '../InfoScreen';
import UserNameScreen from '../UserNameScreen';
import QuizStarter from '../QuizStarter';
import SolidButton from 'components/SolidButton';

const PregnancyPath = ({ startSurvey }) => {
  const { t } = useTranslation();

  const { params } = useEvieOnboardingContext();
  const [path] = useLocalStorage(KEYS.PATH);

  const { step, push } = useGetParams();

  const handleNext = () => {
    handleTrackEvent('Step clicked', { number: step + 1 });
    push(`${ROUTES.EVIE_ONBOARDING}?${params}&step=${step + 1}`);
  };

  return (
    <>
      {step === 2 && (
        <InfoScreen staticimg>
          <LazyLoadImage effect="opacity" src={pregnantWomen} alt="Two pregnant women" className="info-screen__bgimg" />
          <section className="info-screen__footer">
            <div className="info-screen__footer_topbg" />
            <div className="info-screen__footer_topbg second" />
            <div className="info-screen__footer_icon">
              <img src={smile} alt="smily" />
            </div>
            <h2 className="info-screen__footer_title">{t('evieOnboarding.infoScreen.pregnancy.title1')}</h2>
            <p className="info-screen__footer_content">{t('evieOnboarding.infoScreen.pregnancy.description1')}</p>
          </section>
          <SolidButton className="evie-next-icon welcome-screen__next" onClick={handleNext}>
            <GrLinkNext />
          </SolidButton>
        </InfoScreen>
      )}
      {step === 3 && (
        <InfoScreen staticimg>
          <LazyLoadImage effect="opacity" src={pregnantWoman} alt="Pregnant woman" className="info-screen__bgimg" />
          <section className="info-screen__footer">
            <div className="info-screen__footer_topbg" />
            <div className="info-screen__footer_topbg second" />
            <div className="info-screen__footer_icon">
              <img src={tablet} alt="tablet" />
            </div>
            <h2 className="info-screen__footer_title">{t('evieOnboarding.infoScreen.pregnancy.title2')}</h2>
            <p className="info-screen__footer_content">{t('evieOnboarding.infoScreen.pregnancy.description2')}</p>
          </section>
          <SolidButton className="evie-next-icon welcome-screen__next" onClick={handleNext}>
            <GrLinkNext />
          </SolidButton>
        </InfoScreen>
      )}
      {step === 4 && (
        <InfoScreen staticimg>
          <LazyLoadImage effect="opacity" src={pregnantWoman1} alt="Pregnant woman" className="info-screen__bgimg" />
          <section className="info-screen__footer">
            <div className="info-screen__footer_topbg" />
            <div className="info-screen__footer_topbg second" />
            <div className="info-screen__footer_icon">
              <img src={headphones} alt="headphones" />
            </div>
            <h2 className="info-screen__footer_title">{t('evieOnboarding.infoScreen.pregnancy.title3')}</h2>
            <p className="info-screen__footer_content">{t('evieOnboarding.infoScreen.pregnancy.description3')}</p>
          </section>
          <SolidButton className="evie-next-icon welcome-screen__next" onClick={handleNext}>
            <GrLinkNext />
          </SolidButton>
        </InfoScreen>
      )}
      {step === 5 && <UserNameScreen />}
      {step === 6 && (
        <QuizStarter> {/* Añade una clase para el flex direction */}
        <section className="quiz-starter__content">
          <div className="quiz-starter__pregnancy">
            <img src={pregnancyShape} alt="silhouette of pregnant woman" className="quiz-starter__pregnancy_img" />
          </div>
          <div className="quiz-starter__container">
            <img src={star} className="quiz-starter__container_icon" alt="start" />
            <h2 className="quiz-starter__container_title">{t('evieOnboarding.quizStarter.title1')}</h2>
            <p className="quiz-starter__container_description">{t('evieOnboarding.quizStarter.description')} </p>
            <div className='quiz-starter__container_confidential'>
              <img src={rose} alt='rose' className='quiz-starter__container_confidential_icon'/>
              <p className='quiz-starter__container_confidential_text'>{t('evieOnboarding.quizStarter.confidential')}</p>
            </div>
          </div>
        </section>
        <section className="quiz-starter__footer">
          <SolidButton onClick={() => startSurvey(path)}>
            {t('evieOnboarding.quizStarter.button')}
          </SolidButton>
        </section>
        </QuizStarter>
      )}
    </>
  );
};

PregnancyPath.propTypes = {
  startSurvey: PropTypes.func.isRequired,
};

export default PregnancyPath;
